export default __webpack_public_path__ + "static/media/auth.7e302f89.webp";